var ko = {
  "Add Quantity Breaks to your product page": "제품 페이지에 수량 할인 추가",
  "Add Upsell.com to your ": "Upsell.com 추가: ",
  "Add to cart click": "장바구니에 담기 클릭",
  "All time": "전체 기간",
  "and select": "및 선택",
  "button": "버튼",
  "Cart drawer page": "장바구니 서랍 페이지",
  "Cart page": "장바구니 페이지",
  "Check status": "상태 확인",
  "Checkout page": "체크아웃 페이지",
  "Checkout click": "결제 클릭",
  "Click": "클릭",
  "Click on": "클릭",
  "Click the": "클릭",
  "Custom slot": "사용자 지정 슬롯",
  "Custom slots": "사용자 지정 슬롯",
  "Custom Slots": "사용자 지정 슬롯",
  "Enable in theme editor": "테마 편집기에서 사용",
  "contact support.": "지원팀에 문의하세요.",
  "from the right sidebar": "오른쪽 사이드바에서",
  "Go to App Embeds": "앱 임베드로 이동",
  "Go to your Cart drawer page": "장바구니 서랍 페이지로 이동",
  "Go to your Cart page": "장바구니 페이지로 이동",
  "Go to your Checkout page": "체크아웃 페이지로 이동",
  "Go to your Order status page": "주문 상태 페이지로 이동",
  "Go to your Post purchase page": "구매 후 페이지로 이동",
  "Go to your Product page": "제품 페이지로 이동",
  "Go to your Thank you page": "감사 페이지로 이동",
  "items": "항목",
  "in the left sidebar": "왼쪽 사이드바에서",
  "Last 12 months": "지난 12개월",
  "Last 30 days": "지난 30일",
  "Last 365 days": "지난 365일",
  "Last 7 days": "지난 7일",
  "Last 90 days": "지난 90일",
  "Last month": "지난 달",
  "Last year": "작년",
  "Make sure": "확인하세요",
  "Need assistance? Contact our support team for help.": "도움이 필요하신가요? 지원 팀에 문의하세요.",
  "Order status page": "주문 상태 페이지",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "더 나은 경험을 제공하기 위해 앱을 업데이트하고 있습니다.",
  "Post purchase page": "구매 후 페이지",
  "Product page": "제품 페이지",
  "Save": "저장",
  "Scroll to the bottom and select": "맨 아래로 스크롤하여 선택",
  "Select": "선택",
  "Success. Please continue.": "성공. 계속 진행하세요.",
  "Thank you page": "감사 페이지",
  "The Upsell.com team.": "Upsell.com 팀.",
  "The Upsell.com widget is not placed on ": "Upsell.com 위젯이 ",
  ". Please follow the steps above or ": "에 배치되지 않았습니다. 위의 단계를 따르거나 ",
  "Today": "오늘",
  "toggle is on": "토글이 켜져 있는지",
  "Total": "총계",
  "under": "아래",
  "We apologize for any inconvenience caused,": "불편을 드려 죄송합니다,",
  "We apologize for any inconvenience caused.": "불편을 드려 죄송합니다.",
  "We'll be done in a few minutes!": "몇 분 안에 완료됩니다!",
  "We're improving our services!": "서비스를 개선하고 있습니다!",
  "Widget already added": "위젯이 이미 추가됨",
  "Yesterday": "어제",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "온라인 스토어에서 위젯을 활성화했지만 Upsell 편집기에서 저장하지 않았습니다",
  "You placed the widget on the ": "",
  ", but you didn't save it in Shopify editor. Please go back to ": "에 위젯을 배치했지만 Shopify 편집기에서 저장하지 않았습니다. ",
  " and save the changes.": "로 돌아가서 변경 사항을 저장하세요."
};

export { ko as default };
//# sourceMappingURL=ko.json.js.map
